import { apiMiddleware } from 'redux-api-middleware'
import { routerMiddleware } from 'connected-react-router'
import callAPI from 'utils/callAPI'
import keyMirror from 'pkeymirror'

// ------------------------------------
// Constants
// ------------------------------------
export const MAPS_POWER_BANK_STORE = keyMirror(
  {
    INIT_REQUEST: null,
    INIT_SUCCESS: null,
  },
  'MAPS_POWER_BANK_STORE'
)

// ------------------------------------
// Actions
// ------------------------------------
export function init(data) {
  data.pageParam = {
    number: 0,
    size: 1000,
  }

  return (dispatch) => {
    dispatch(
      callAPI({
        dispatch: dispatch,
        method: 'POST',
        body: data,
        forward: false,
        endpoint: 'https://powerbank.payby.com/api/v1.0.0/stations/queryDistancePage',
        requestAction: MAPS_POWER_BANK_STORE.INIT_REQUEST,
        successAction: MAPS_POWER_BANK_STORE.INIT_SUCCESS,
        success: function(result) {},
      })
    )
  }
}

// ------------------------------------
// Action Handlers
// ------------------------------------
const ACTION_HANDLERS = {
  [MAPS_POWER_BANK_STORE.INIT_REQUEST]: (state, action) => Object.assign({}, state, { storeList:[] }),
  [MAPS_POWER_BANK_STORE.INIT_SUCCESS]: (state, action) => Object.assign({}, state, { storeList:action.payload.content }),
}

// ------------------------------------
// Reducer
// ------------------------------------
const initialState = {}
function reducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default function(history) {
  return {
    id: 'mapsPowerBankStore',
    reducerMap: {
      mapsPowerBankStoreState: reducer
    },
    // middlewares when this module needed
    middlewares: [apiMiddleware, routerMiddleware(history)]
    // Actions to fire when this module is added/removed
    // initialActions: [],
    // finalActions: []
  }
}
